import UserContext from '@context/User/UserContext'
import dashboardRoutesPaths from '@helpers/dashboardRoutesPaths/dashboardRoutesPaths'
import { getFolioContratoCompra } from '@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos'
import { retrieveCheckoutSessionStripe } from '@helpers/httpRequests/httpRequestSuscripciones/httpRequestsSuscripciones'
import ThumbUpSvg from '@helpers/resources/ThumbUpSvg'
import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'

const SuscripcionRealizada = ({history}) => {

    const {contextValue, setContextValue} = useContext(UserContext);

    const [folioContrato, setFolioContrato] = useState("");

    const [checkSession, setCheckSession] = useState('');

    const [nombreSuscripcion, setNombreSuscripcion] = useState('');

    const [planSuscripcion, setPlanSuscripcion] = useState('');


    //TODO Replicar el proceso de inscripción para SAI y plataforma a partir de esta vista:
    /**
     ** -Obtener un folio de la base de datos
     ** -Asignarlo y agregar un btn para registrar en SAI y generar su contrato.
     ** -Que reciba su correo de completar registro para que el usuario concluya con el formulario de registro inicial.
     ** -Agregar la validacion necesaria para que reciba los parametros desde el success url y pueda asignarse un folio, en caso de que no se pasen las validciones que se muestre un mensaje de error o aviso de que algo salio mal etc...
     **
     */


     const handleGoToRegister = () => {
     
           
     
            console.log(`${dashboardRoutesPaths.rawFormularioRegistroSai}/${folioContrato}`)
     
            history.replace(`${dashboardRoutesPaths.rawFormularioRegistroSai}/${folioContrato}?subscription=${checkSession}`);
        };




    const consultarFolioCompra = async () => {
        try {

            let folioContrato;

            const { folioContrato: folio } = await getFolioContratoCompra();
            folioContrato = folio

            console.log(folioContrato)
            setFolioContrato(folioContrato);

            setContextValue({
                ...contextValue,
                compra: {
                    ...contextValue.compra,
                    folioContrato,
                },
            });
        } catch (error) {
            console.log("error al obtener el folio de contrato: ", error);
        }
    };

    const recuperarInfoParams = () =>{
        //Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		let infoSuscripcion = param.get("session_id")

        if(infoSuscripcion){
            setCheckSession(infoSuscripcion);
        }
    }

    const recuperarSuscripcion = async() => {
        try {
            const infoSuscripcion = await retrieveCheckoutSessionStripe({checkSessionId: checkSession});

            console.log(infoSuscripcion);

            setNombreSuscripcion('Licencia Click+ Academy Ofimática');

            setPlanSuscripcion(infoSuscripcion.session.subscription.plan.interval === 'year' ? 'Facturación Anual' : 'Facturación Mensual' );
            
            
        } catch (error) {
            console.log("Error al recuperar la informacion de la suscripcion")
        }
    }

    useEffect(() => {
        
        if (folioContrato === "") {
            recuperarInfoParams();
            consultarFolioCompra();
        }
    }, []);

    useEffect(() => {
        recuperarSuscripcion();
    }, [checkSession])
    


    return (
        <Container className='bg-suscripcion' fluid style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: "center", height: "100vh", overflowY: "scroll" }}>
            <Row className='my-5 p-4  flex flex-row align-items-center justify-content-center' style={{ backgroundColor: "transparent", color: '#fff' }}>
                {/* <Col lg={4} className='text-center'>
                
            </Col> */}

                <Col lg={6} xl={4} className='rounded text-center rounded-lg text-lg-start m-4 ' style={{ backgroundColor: "#f2f2f2", color: "#212529" }}>
                    <div >
                        <div className='text-center mt-3'>
                            <ThumbUpSvg />
                            <h2 className='mt-4 text-success'>¡Compra realizada!</h2>
                        </div>
                        <h2 className='m-3 text-center'>Has adquirido:</h2>
                        <h3 className='m-3 text-center'>{nombreSuscripcion}</h3>
                        <h4 className='text-center text-warning'>{planSuscripcion}</h4>
                        <div className='p-0 p-lg-3'>
                            <h4>Incluye:</h4>
                            <ul className='mt-3'>
                                <li>Paquete Ofimática básico (Excel, PowerPoint, Word, PowerBI)</li>
                                <li>Curso de regalo (Se renueva mes con mes)</li>
                            </ul>

                            <Button onClick={handleGoToRegister} className="mb-3 w-100">Comenzar registro</Button>
                        </div>

                        {/* <div className='text-center my-4 p-4'>
                        <small>Recibirás un correo electrónico de <b>notificaciones@globalclickmexico.com</b> con las instrucciones para completar tu registro en la plataforma.</small>
                    </div> */}
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default SuscripcionRealizada